import Vue from 'vue';
import VueResource from 'vue-resource';
import { EventEmitter } from 'events';

Vue.use(VueResource);
class Api {
  constructor(ee = new EventEmitter()) {
    this.ee = ee;
    this.url = '/api';
    this.token = '';
    this.ws = null;
    this.requests = [];
    Vue.http.interceptors.push((request, next) => {
      request.headers.set('Token', this.getToken());
      next();
    });

  }
  error(err) {
    this.ee.emit('loaded');
    if (err.status == 401) {
      this.ee.emit('logout');
    } else {
      this.ee.emit('error', err);
    }
    return Promise.reject(err);
  }

  setToken(token) {
    this.token = token;
    try {
      const url = new URL(document.location);
      url.protocol = url.protocol.replace('http', 'ws');
      url.pathname = '/ws';
      url.hash = '';
      url.search = `token=${this.token}`;
      if (this.token) {
        this.ws = new WebSocket(url);
        this.ws.onmessage = event => {
          this.ee.emit('message', event);
        };
        this.ws.onclose = event => {
          this.ee.emit('closed', event);
        };
        this.ws.onopen = event => {
          console.log('open event ', event);
        };
        this.ws.onerror = event => {
          this.ee.emit('error', event);
        };
        console.log(this.ws);
      } else if (this.token == null && this.ws) {
        this.ws.close();
      }
    } catch (e) {
      console.log(e);
    }
  }
  getToken() {
    return this.token;
  }
  health() {
    if (this.token) {
      Vue.http.get(this.url + '/health', {}).catch(this.error.bind(this));
    }
  }
  post(url, body, options) {
    this.ee.emit('loading');
    let req = Vue.http.post(this.url + url, body, options || {});
    this.requests.push(req);
    return req
      .then(result => {
        this.ee.emit('loaded');
        return result;
      })
      .catch(this.error.bind(this));
  }
  put(url, body, options) {
    this.ee.emit('loading');
    let req = Vue.http.put(this.url + url, body, options || {});
    this.requests.push(req);
    return req
      .then(result => {
        this.ee.emit('loaded');
        return result;
      })
      .catch(this.error.bind(this));
  }
  delete(url, options) {
    this.ee.emit('loading');
    let req = Vue.http.delete(this.url + url, options);
    this.requests.push(req);
    return req
      .then(result => {
        this.ee.emit('loaded');
        return result;
      })
      .catch(this.error.bind(this));
  }
  get(url, options) {
    this.ee.emit('loading');
    let req = Vue.http.get(this.url + url, options || {});
    this.requests.push(req);
    return req
      .then(result => {
        this.ee.emit('loaded');
        return result;
      })
      .catch(this.error.bind(this));
  }

  on(name, fn) {
    this.ee.on(name, fn);
  }
  off(name, fn) {
    this.ee.removeListener(name, fn);
  }
}

export default (function() {
  var instance;
  if (!instance) {
    instance = new Api();
  }
  return instance;
})();



// WEBPACK FOOTER //
// ./src/api/index.js